import { ExportEventType } from "@/constant/export/ExportEventType";
import { ExportJobStatus } from "@/constant/export/ExportJobStatus";
import {
  updateFileDataInDownload,
  updateFileProgressInDownload,
} from "@/store/slices/fileDownload/fileDownloadSlice";
import type { AppDispatch } from "@/store/store";
import { subscribeToPrivateChannel } from "@/utils/socketManager/socketManager";
import { memo, useEffect } from "react";
import { useDispatch } from "react-redux";

interface ProcessExportEventsTypes {
  ablyClient: any;
  clientId: string;
}

function ProcessExportEvents({
  ablyClient,
  clientId,
}: ProcessExportEventsTypes) {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (ablyClient && clientId) {
      subscribeToPrivateChannel(
        ablyClient,
        clientId,
        ExportEventType.EXPORT_PROGRESS,
        (message: any) => {
          const data = JSON.parse(message?.data);
          if (data?.status === "PROGRESS") {
            dispatch(
              updateFileProgressInDownload({
                jobId: data?.jobId,
                progressPercent: data?.progress,
              })
            );
          }
        }
      );
      subscribeToPrivateChannel(
        ablyClient,
        clientId,
        ExportEventType.EXPORT_DELIVERY,
        (message: any) => {
          const data = JSON.parse(message?.data);
          if (data?.status === "SUCCESS") {
            dispatch(
              updateFileDataInDownload({
                jobId: data?.jobId,
                url: data?.url,
                status: ExportJobStatus.SUCCESS,
                errorMessage: null,
              })
            );
          }
        }
      );
      subscribeToPrivateChannel(
        ablyClient,
        clientId,
        ExportEventType.EXPORT_FAILED,
        (message: any) => {
          const data = JSON.parse(message?.data);
          if (data?.status === "FAILED") {
            dispatch(
              updateFileDataInDownload({
                jobId: data?.jobId,
                url: "",
                status: ExportJobStatus.FAILED,
                errorMessage: data?.error,
              })
            );
          }
        }
      );
    }
  }, [ablyClient, clientId]);
  return null;
}

export default memo(ProcessExportEvents);
